import { jsx as _jsx } from "react/jsx-runtime";
import guid from '@/shared/utils/guid';
import UserSearch from '../UserSearch';
export var FilterUserSearch = function (_a) {
    var item = _a.item, setFilter = _a.setFilter, activeFilters = _a.activeFilters, label = _a.label, isAlwaysVisible = _a.isAlwaysVisible, enabled = _a.enabled, withUnassigned = _a.withUnassigned;
    return ({
        filterItem: item,
        enabled: enabled,
        filterSelectLabel: !isAlwaysVisible ? label : undefined,
        element: (_jsx(UserSearch, { onChange: function (value) {
                var _a;
                var _b;
                return setFilter((_a = {}, _a[item] = (_b = value === null || value === void 0 ? void 0 : value.id) !== null && _b !== void 0 ? _b : undefined, _a));
            }, value: activeFilters[item], placeholder: label, withCurrentUser: true, withUnassigned: withUnassigned, unassignedId: guid.empty, hideClearButton: !withUnassigned })),
    });
};
